import React, { Component } from 'react';
import { IconButton, Menu, MenuItem, ListItemText } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { toast } from "react-toastify";
import spinner from "../../assign-prescriptions/images/spinner.gif";

class VerticalMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: this.props.data,
      selected: [],
      anchorEl: null,
      selectedRowId: null,
      disabledUserText: this.props.t("Report.inActive.Disable"),
      openUserDeleteDialog: false,
      userDeletionArr: [],
      openUserDisabledDialog: false,
      userDisabledArr: [],
    }
  }

  handleContextClick = (event) => {
    event.preventDefault();
    const { t, contextData } = this.props;
    let disabledText;
    if ((contextData && contextData.is_enabled) === "true" || (contextData && contextData.is_enabled) === true) {
      disabledText = t("Report.inActive.Disable");
    } else {
      disabledText = t("Report.inActive.Enable");
    }
    this.setState({
      anchorEl: event.currentTarget,
      selectedRowId: contextData.id,
      disabledUserText: disabledText
    })
  };

  handleContextClose = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: null, selectedRowId: null });
  };

  handleConfirmDelete = () => {
    if (this.state && this.state.selectedRowId) {
      this.setState({
        openUserDeleteDialog: true,
        userDeletionArr:
          this.state &&
          this.state.data.filter((x) => x.id === this.state.selectedRowId),
      });
    } else {
      this.setState({
        openUserDeleteDialog: true,
        userDeletionArr:
          this.state &&
          this.state.data.filter(
            (x) => this.state && this.state.selected.indexOf(x.id) > -1
          ),
      });
    }
  };

  handleConfirmClose = (event) => {
    if (this.state && this.state.selectedRowId) {
      this.setState({
        openUserDeleteDialog: false,
        selectedRowId: null,
        userDeletionArr: [],
        selected: [],
      });
      this.handleContextClose(event);
    } else
      this.setState({
        openUserDeleteDialog: false,
        selectedRowId: null,
        userDeletionArr: [],
        selected: [],
      });
  };

  handleDeleteConfirmed = (event) => {
    if (this.state && this.state.selectedRowId) {
      this.handleDeleteUser(event);
    } else {
      this.handleDeleteMultipleUsers();
    }
    this.setState({ openUserDeleteDialog: false });
  };

  handleDeleteUser = (event) => {
    this.setState({ loader: true });
    const selecRowID = this.state && this.state.selectedRowId;
    fetch(process.env.REACT_APP_BASEURL + "users/" + selecRowID, {
      method: "DELETE",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    }).then((results) => {
      this.setState({ loader: false });
      const _updatedUsers = this.state.data.filter(
        (x) => x.id !== this.state.selectedRowId
      );
      this.handleContextClose(event);
      this.setState({
        data: JSON.parse(JSON.stringify(_updatedUsers)),
        selected: [],
        selectedRowId: null,
      });
    });
  };

  handleDeleteMultipleUsers = () => {
    this.setState({ loader: true });
    const result = fetch(
      process.env.REACT_APP_BASEURL +
      "users/" +
      this.state.selected.join(",").trim(","),
      {
        method: "DELETE",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result.then((result) => {
      this.setState({ loader: false });
      const newData = [];
      this.state.data.forEach((item) => {
        if (this.state.selected.indexOf(item.id) === -1) {
          newData.push(item);
        }
      });

      this.setState({
        data: JSON.parse(JSON.stringify(newData)),
        selected: [],
      });
    });
  };

  handleDisabledConfirmClose = (event) => {
    if (this.state && this.state.selectedRowId) {
      this.setState({
        openUserDisabledDialog: false,
        selectedRowId: null,
        userDisabledArr: [],
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        openUserDisabledDialog: false,
        selectedRowId: null,
        userDisabledArr: [],
      });
    }
  };

  hanldeConfirmDisabledUsers = (event) => {
    if (this.state && this.state.selectedRowId) {
      this.handleDisabledUser(event);
      this.setState({ openUserDisabledDialog: false });
      toast.success(
        `${this.props.t('Toast.User')} ${this.state && this.state.disabledUserText} ${this.props.t('Toast.Success')}`
      );
    }
  };

  handleConfirmDisabled = () => {
    if (this.state && this.state.selectedRowId) {
      this.setState({
        openUserDisabledDialog: true,
        userDisabledArr:
          this.state &&
          this.state.data.filter((x) => x.id === this.state.selectedRowId),
      });
    } else {
      this.setState({
        openUserDisabledDialog: true,
        userDisabledArr:
          this.state &&
          this.state.data.filter((x) => this.state.selected.indexOf(x.id) > -1),
      });
    }
  };

  handleDisabledUser = (event) => {
    this.setState({ loader: true });
    const rowIdToDisable = this.state.selectedRowId;
    const DisUser = {
      id: rowIdToDisable,
      is_enabled:
        this.state.disabledUserText.toLowerCase() ===
          String(this.props.t("Report.inActive.Disable")).toLowerCase()
          ? false
          : true,
    };
    const result = fetch(process.env.REACT_APP_BASEURL + "userdis/", {
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(DisUser),
    }).then((response) => {
      try {
        return response.text();
      } catch (error) {
        return null;
      }
    });
    result.then((result) => {
      this.setState({ loader: false });
      this.handleContextClose(event);
      this.props.api.refreshServerSide()
    });
  };

  render() {
    const { classes, t } = this.props;
    const {
      anchorEl,
      loader,
      openUserDeleteDialog,
      userDeletionArr,
      openUserDisabledDialog,
      userDisabledArr,
      disabledUserText
    } = this.state;
    const contextOpen = Boolean(anchorEl);

    return (
      <div>
        {
          loader ? (
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div>
          ) : null
        }
        {/* Start Delete Dialog.. */}
        <Dialog
          open={openUserDeleteDialog || false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("Report.inActive.AreYouSureText")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {t("Report.inActive.AreYouSureBodyText")}
              <ul>
                {userDeletionArr &&
                  userDeletionArr.length > 0 &&
                  userDeletionArr.map((ele, index) => {
                    return <li key={index}>{ele && ele.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleConfirmClose}
              color="primary"
              className={classes.primaryButton}
            >
              {t("Report.inActive.CancelButton")}
            </Button>
            <Button
              onClick={this.handleDeleteConfirmed}
              color="primary"
              autoFocus
              className={classes.primaryButton}
            >
              {t("Report.inActive.DeleteButton")}
            </Button>
          </DialogActions>
        </Dialog>
        {/* End Delete Dialog..*/}
        {/* Start User Disable Dialog */}
        <Dialog
          open={openUserDisabledDialog || false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("Report.inActive.AreYouSureWantTo")}{" "}
            {`${this.state && disabledUserText}?`}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {t("Report.inActive.AreYouSureWantTo")}{" "}
              {this.state && disabledUserText} user(s):
              <ul>
                {userDisabledArr &&
                  userDisabledArr.map(function (x, index) {
                    return <li key={index}>{x.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleDisabledConfirmClose}
              color="primary"
              className={classes.primaryButton}
            >
              {t("Report.inActive.CancelButton")}
            </Button>
            <Button
              onClick={this.hanldeConfirmDisabledUsers}
              color="primary"
              autoFocus
              className={classes.primaryButton}
            >
              {t("Report.inActive.YesButton")}
            </Button>
          </DialogActions>
        </Dialog>
        {/* End User Disabled Dialog.. */}
        <IconButton
          aria-label="vertical menu"
          aria-controls="menu"
          aria-haspopup="true"
          onClick={this.handleContextClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="menu"
          anchorEl={anchorEl}
          keepMounted
          open={contextOpen}
          onClose={this.handleContextClose}
        >
          <MenuItem key="disable-key"
            onClick={this.handleConfirmDisabled}
            sx={{ height: "40px" }}>
            <ListItemText>
              {this.state && disabledUserText}
            </ListItemText>
          </MenuItem>
          <MenuItem
            key="delete-key"
            onClick={this.handleConfirmDelete}
            sx={{ height: "40px" }}
          >
            <ListItemText>{t("Report.inActive.Delete")}</ListItemText>
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

export default VerticalMenu;



// WEBPACK FOOTER //
// ./src/components/reports/users-inactive-report/ActionCellRenderer.js